import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MultiDeviceInteractionState } from '../../../models/consumer/consumer-interaction.model';
import { MultiDeviceInteractionService } from '../../../services/multi-device-interaction.service';
import { Router, ActivatedRoute } from '@angular/router';

class ItemModel {
    type: MultiDeviceInteractionState;
    isComplete: boolean;
    isShown: boolean;
};

@Component({
    selector: 'multi-device-header',
    templateUrl: './multi-device-header.component.html',
    styles: []
})
export class MultiDeviceHeaderComponent implements OnInit, OnDestroy {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private multiDeviceInteractionService: MultiDeviceInteractionService
    ) { }

    @Input() state: MultiDeviceInteractionState;
    activeState: MultiDeviceInteractionState;
    subscriptions: any[] = [];
    items: ItemModel[] = [
        {
            type: MultiDeviceInteractionState.what,
            isComplete: false,
            isShown: true
        },
        {
            type: MultiDeviceInteractionState.when,
            isComplete: false,
            isShown: true
        },
        {
            type: MultiDeviceInteractionState.how,
            isComplete: false,
            isShown: false
        },
        {
            type: MultiDeviceInteractionState.who,
            isComplete: false,
            isShown: true
        },
        {
            type: MultiDeviceInteractionState.summary,
            isComplete: false,
            isShown: false
        }
    ];

    ngOnInit() { }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    ngOnChanges(change: SimpleChanges) {
        if (change.state) {
            this.activeState = change.state.currentValue;

            //get interaction models from session storage
            let whatModel = this.multiDeviceInteractionService.whatModel;

            this.items.find(x => x.type == MultiDeviceInteractionState.how).isShown = false;
            if (whatModel && !whatModel.isGet) {
                this.items.find(x => x.type == MultiDeviceInteractionState.how).isShown = whatModel.isSkipHow ? false : true;
            }

            let isDefined = (value) => {
                return !(value == undefined || value == null);
            };

            let index = this.items.findIndex(x => x.type == this.activeState);
            this.items.forEach((item, i) => {
                let isComplete = i < index;

                switch (item.type) {
                    case MultiDeviceInteractionState.what:
                        isComplete = isDefined(this.multiDeviceInteractionService.whatModel);
                        break;
                    case MultiDeviceInteractionState.when:
                        isComplete = isDefined(this.multiDeviceInteractionService.whenModel);
                        break;
                    case MultiDeviceInteractionState.how:
                        isComplete = isDefined(this.multiDeviceInteractionService.howModel);
                        break;
                    case MultiDeviceInteractionState.who:
                        isComplete = isDefined(this.multiDeviceInteractionService.whoModel);
                        break;
                }

                item.isComplete = isComplete;
            });
        }
    }

    onClick(item: ItemModel) {
        if (!item.isComplete) return;

        this.router.navigated = false;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { state: item.type }
        });
    }
}
